import { createSlice } from "@reduxjs/toolkit";
import {
  getFrasesByPlantelThunk,
  createPhraseByPlantelThunk,
  getPhraseByPlantelByIdThunk,
  togglePhraseActiveThunk,
} from "./plantels.thunks";

const initialState = {
  list: [],
  loading: false,
  error: null,

  page: 1,
  pageSize: 10,
  count: 0,

  filters: {
    talentoPlantelId: null,
    isRandom: false,
  },

  //  FORM
  formModalOpen: false,
  formLoading: false,
  formError: null,

  selectedPhrase: null,
  selectedPhraseLoading: false,
  selectedPhraseError: null,
  viewPhraseModalOpen: false,

  confirmModalOpen: false,
  togglePhraseId: null,
  toggling: false,
};

const frasesSlice = createSlice({
  name: "frasesByPlantel",
  initialState,
  reducers: {
    setFrasesPage: (state, action) => {
      state.page = action.payload;
    },

    setFrasesFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
      state.page = 1;
    },

    openPhraseForm: (state) => {
      state.formModalOpen = true;
      state.formError = null;
    },

    closePhraseForm: (state) => {
      state.formModalOpen = false;
      state.formError = null;
    },
    openPhraseView: (state) => {
      state.viewPhraseModalOpen = true;
    },
    closePhraseView: (state) => {
      state.viewPhraseModalOpen = false;
      state.selectedPhrase = null;
    },
    openPhraseConfirmToggle: (state, action) => {
      state.confirmModalOpen = true;
      state.togglePhraseId = action.payload.id;
    },
    closePhraseConfirmToggle: (state) => {
      state.confirmModalOpen = false;
      state.togglePhraseId = null;
    },
  },

  extraReducers: (builder) => {
    builder

      // GET LIST
      .addCase(getFrasesByPlantelThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getFrasesByPlantelThunk.fulfilled, (state, action) => {
        state.loading = false;

        const payload = action.payload;
        state.list = payload.results || payload || [];
        state.count = payload.count || state.list.length;
      })
      .addCase(getFrasesByPlantelThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // CREATE
      .addCase(createPhraseByPlantelThunk.pending, (state) => {
        state.formLoading = true;
        state.formError = null;
      })
      .addCase(createPhraseByPlantelThunk.fulfilled, (state, action) => {
        state.formLoading = false;
        state.list = [action.payload, ...state.list];
        state.formModalOpen = false;
      })
      .addCase(createPhraseByPlantelThunk.rejected, (state, action) => {
        state.formLoading = false;
        state.formError = action.payload;
      })
      .addCase(getPhraseByPlantelByIdThunk.pending, (state) => {
        state.selectedPhraseLoading = true;
        state.selectedPhraseError = null;
      })
      .addCase(getPhraseByPlantelByIdThunk.fulfilled, (state, action) => {
        state.selectedPhraseLoading = false;
        state.selectedPhrase = action.payload;
      })
      .addCase(getPhraseByPlantelByIdThunk.rejected, (state, action) => {
        state.selectedPhraseLoading = false;
        state.selectedPhraseError = action.payload;
      })
      .addCase(togglePhraseActiveThunk.pending, (state) => {
        state.toggling = true;
      })
      .addCase(togglePhraseActiveThunk.fulfilled, (state, action) => {
        state.toggling = false;

        const id = state.togglePhraseId;
        const phrase = state.list.find((p) => p.id === id);

        if (phrase) {
          phrase.is_active = !phrase.is_active;
        }

        if (state.selectedPhrase?.id === id) {
          state.selectedPhrase.is_active = !state.selectedPhrase.is_active;
        }

        state.confirmModalOpen = false;
      })
      .addCase(togglePhraseActiveThunk.rejected, (state) => {
        state.toggling = false;
      });
  },
});

export const {
  setFrasesPage,
  setFrasesFilters,
  openPhraseForm,
  closePhraseForm,
  openPhraseView,
  closePhraseView,
  openPhraseConfirmToggle,
  closePhraseConfirmToggle,
} = frasesSlice.actions;

export default frasesSlice.reducer;
